/**
 * Application Entry Point
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import toast from 'react-hot-toast';

import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register({
  onUpdate: () => {
    toast('A new version is available. Refresh to update.', {
      duration: Infinity,
      position: 'bottom-center',
    });
  },
});
